import Lottie from "lottie-react";
import './NoPropertiesAnimation.css';

// Import the Lottie animation data
import animationData from '../../assets/animations/real-estate-no-properties.json';

const NoPropertiesAnimation = ({ type }) => {
  const handleAnimationError = () => {
    console.warn('Lottie animation failed to load');
  };

  return (
    <div className="no-properties-animation">
      <div className="animation-container">
        <div className="lottie-animation">
          <Lottie 
            animationData={animationData}
            loop={true}
            autoplay={true}
            style={{ width: '100%', height: '100%' }}
            onError={handleAnimationError}
            onLoadError={handleAnimationError}
          />
        </div>
      </div>
      
      <div className="animation-text">
        <h3>No Properties Found</h3>
        <p>
          {type 
            ? `No ${type} properties found matching your criteria.` 
            : 'No properties found matching your criteria.'
          }
        </p>
        <p className="suggestion">Try adjusting your search filters to discover amazing properties.</p>
      </div>
    </div>
  );
};

export default NoPropertiesAnimation;